module.exports = __webpack_public_path__ + "static/media/SuperShuttle_ios_2_preview.d08db7bd.jpg";